import { BrowserRouter } from "react-router-dom";
import RootRouter from "./view/RootRouter";
import "./view/styles/reset.scss";
import { useEffect } from "react";
import { Toaster, toast, useToasterStore } from "react-hot-toast";

function App() {
  const { toasts } = useToasterStore();
  const TOAST_LIMIT = 1;

  // Enforce Toast Limit
  useEffect(() => {
    toasts
      .filter((t) => t.visible)
      .filter((_, i) => i >= TOAST_LIMIT)
      .forEach((t) => toast.dismiss(t.id));
  }, [toasts]);

  return (
    <BrowserRouter>
      <RootRouter />
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
